<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <alerts></alerts>
            <BodiesListTable
                v-bind="$attrs"
                :route="routes"
            ></BodiesListTable>
        </div>
    </div>
</template>

<script>
import BodiesListTable from '../bodies/BodiesListTable';

export default {
    components: {
        BodiesListTable,
    },
    data: function () {
        return {
            routes: {
                category: this.$route.path + '/categories/:id:',
                show: '/predefined-bodies/:id:',
                edit: '/predefined-bodies/:id:/edit',
                deactivate: '/predefined-bodies/:id:/active/0',
                active: '/predefined-bodies/:id:/active/1',
            },
        };
    },
};
</script>
